const moveLink = () => {
    const tiles = [...document.querySelectorAll('.tile.single')];
    if (tiles) {
        tiles.forEach((tile) => {
            const tileLink = tile.querySelector('a.item-link');
            const description = tile.querySelector('.description');

            if (tileLink && description) {
                const newLink = document.createElement('a');
                newLink.setAttribute('href', tileLink.getAttribute('href'));
                newLink.appendChild(description);
                tile.appendChild(newLink);

            }
        });
    }
};

module.exports = { moveLink };


// WEBPACK FOOTER //
// ./scriptPartials/moveLink.js